import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import { ShipEngine } from '../ShipEngine'

@InputType()
export class AddShipEngineArgs extends ActionArgs {
  @Field(() => ShipEngine)
  shipment: ShipEngine
}

export interface IAddShipEngine extends IAction<void, AddShipEngineArgs> {}
